import type { QueryClient } from '@tanstack/react-query';

import { useJackpotStore } from '../state_management_and_stores/jackpot.store';
import { usePatternStore } from '../state_management_and_stores/pattern.store';
import { useRodeoStore } from '../state_management_and_stores/rodeo.store';
import { useTeamStore } from '../state_management_and_stores/team.store';

// Wipes all per-user client state — React Query cache and every Zustand
// store that holds user-scoped data. Called on logout (so the next user
// can never see the previous user's data) and on login (defense in depth
// in case logout cleanup was bypassed, e.g. session expiry in another tab).
export function resetClientState(queryClient: QueryClient): void {
  queryClient.cancelQueries();
  queryClient.clear();

  useJackpotStore.getState().resetWizard();
  useRodeoStore.getState().resetWizard();
  useTeamStore.getState().resetTeamStore();
  usePatternStore.getState().resetPatterns();
}
